import { render, staticRenderFns } from "./systemUpgrade.vue?vue&type=template&id=0bb0a7a8&scoped=true"
import script from "./systemUpgrade.vue?vue&type=script&lang=js"
export * from "./systemUpgrade.vue?vue&type=script&lang=js"
import style0 from "./systemUpgrade.vue?vue&type=style&index=0&id=0bb0a7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0a7a8",
  null
  
)

export default component.exports